import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { CounterpartyIdField } from '@/pages/instruments/new-instrument/form-fields/CounterpartyIdField'
import { CountryIdFormField } from '@/pages/instruments/new-instrument/form-fields/CountryIdFormField'
import { CurrencyIdField } from '@/pages/instruments/new-instrument/form-fields/CurrencyIdField'
import { DescriptionFormField } from '@/pages/instruments/new-instrument/form-fields/DescriptionFormField'
import { ISINField } from '@/pages/instruments/new-instrument/form-fields/ISINField'
import { IssuerNameFormField } from '@/pages/instruments/new-instrument/form-fields/IssuerNameFormField'
import { MaturityDateField } from '@/pages/instruments/new-instrument/form-fields/MaturityDateField'
import { QuoteFactorFormField } from '@/pages/instruments/new-instrument/form-fields/QuoteFactorFormField'
import { TopLevelBucketFormField } from '@/pages/instruments/new-instrument/form-fields/TopLevelBucketFormField'
import { UnitMultiplierFormField } from '@/pages/instruments/new-instrument/form-fields/UnitMultiplierFormField'
import { BondSchemaType } from '@/pages/instruments/new-instrument/schemas/bond.schema'

export interface BondFormFieldsProps {}

export const BondFormFields: React.FC<BondFormFieldsProps> = ({}) => {
  const { trigger } = useFormContext<BondSchemaType>()

  useEffect(() => {
    trigger()
  }, [])

  return (
    <div className={'@container flex flex-col gap-4'}>
      <FormFieldRow>
        <CurrencyIdField />
        <ISINField />
        <MaturityDateField />
        <CounterpartyIdField />
      </FormFieldRow>
      <FormFieldRow>
        <IssuerNameFormField />
        <CountryIdFormField />
        <TopLevelBucketFormField />
      </FormFieldRow>
      <FormFieldRow>
        <UnitMultiplierFormField />
        <QuoteFactorFormField />
      </FormFieldRow>
      <DescriptionFormField />
    </div>
  )
}
